export function isValidArray(value: unknown) {
  return Array.isArray(value) && value.length > 0
}

export function isValidString(value: unknown) {
  return typeof value === 'string' && value.trim().length > 0
}
